export const services = {
  PERSONAL_STYLING: {
    name: 'personalStyling',
    basename: '/appointments/personal-styling',
  },
  NURSERY: {
    name: 'nursery',
    basename: '/appointments/nursery',
  },
  CHILDREN_SHOE_FITTING: {
    name: 'childrensShoeFitting',
    basename: '/appointments/childrens-shoe-fitting',
  },
  FITTED_BATHROOMS: {
    name: 'fittedBathrooms',
    basename: '/appointments/fitted-bathrooms',
  },
  FITTED_BEDROOMS: {
    name: 'fittedBedrooms',
    basename: '/appointments/fitted-bedrooms',
  },
  FITTED_KITCHENS: {
    name: 'fittedKitchens',
    basename: '/appointments/fitted-kitchens',
  },
  PELOTON: {
    name: 'peloton',
    basename: '/appointments/peloton',
  },
  LINGERIE: {
    name: 'lingerie',
    basename: '/appointments/lingerie',
  },
  OPTICAL_SERVICES: {
    name: 'opticalServices',
    basename: '/appointments/optical-services',
  },
  HOME_DESIGN: {
    name: 'homeDesign',
    basename: '/appointments/home-design',
  },
  BEAUTY_SOCIETY: {
    name: 'beautySociety',
    basename: '/appointments/beauty-society',
  },
  BEAUTY: {
    name: 'beauty',
    basename: '/appointments/beauty',
  },
  MEASURE: {
    name: 'measure',
    basename: '/appointments/measure',
  },
  MANAGE_APPOINTMENTS: {
    basename: '/appointments/manage-appointments',
  },
  HOME_SERVICES: {
    name: 'homeServices',
    basename: '/appointments/home-services',
  },
  PIERCING: {
    name: 'piercing',
    basename: '/appointments/piercing',
  },
  RELEASE_INFORMATION: {
    basename: '/appointments/release-information',
  },
  SERVICE_UNAVAILABLE: {
    basename: '/appointments/service-unavailable',
  },
};
